import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// actions
import { updateMinutesFilter } from 'js/store/search/Search.actions';

// selectors
import { getTranslationById } from 'js/store/app/App.selectors';
import { getAvailableOptionsById } from 'js/store/search/Search.selectors';

// components
import ButtonBasic from '../button/Button.basic';

const SELECTED_COLOR = '#f7ebb1';
const UNSELECTED_COLOR = '#003764';

const MINUTE_OPTIONS = [
  { id: 'minutes_1', label: '< 5' },
  { id: 'minutes_2', label: '5-20' },
  { id: 'minutes_3', label: '+20' },
];

const FindMinutesOptions = () => {
  const dispatch = useDispatch();
  const availableMinutes = useSelector((state) => getAvailableOptionsById(state, 'minutes'));

  const selectedMinutes = useSelector((state) => state?.search?.filters?.minutes);

  const title = useSelector((state) => getTranslationById(state, 'find_step_2_minutes_title', 'How many minutes?'));

  const updateSelection = useCallback(
    (minutesId) => {
      dispatch(updateMinutesFilter(minutesId));
    },
    [dispatch]
  );

  const getButtonStyle = (isSelected) => ({
    backgroundColor: isSelected ? SELECTED_COLOR : 'transparent',
    border: `3px solid ${isSelected ? SELECTED_COLOR : UNSELECTED_COLOR}`,
    color: UNSELECTED_COLOR,
  });

  return (
    <>
      <h2 className="find__title find__minutes-title">{title}</h2>

      <ul className="find__minute-options">
        {MINUTE_OPTIONS.map(({ id, label }) => {
          const isSelected = selectedMinutes.includes(id);
          const isAvailable = availableMinutes.includes(id);

          return (
            <li key={id} className={isSelected ? 'active' : ''}>
              <ButtonBasic
                title={label}
                action={() => {
                  isAvailable && updateSelection(id);
                }}
                style={getButtonStyle(isSelected)}
                disabled={!isAvailable}
              />
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default FindMinutesOptions;
